import { applications } from './groups/applications';
import { pages } from './groups/pages';

export enum NavigationGroup {
  Pages = 0,
  Applications = 1,
  QuickLinks = 2,
}
export const navigation = [pages, applications /* QuickLinks */];
